import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import View from './View';
var Container = function (_a) {
    var attachmentsLinks = _a.attachmentsLinks, itemIndex = _a.itemIndex;
    return _jsx(View, { itemIndex: itemIndex, attachmentsLinks: attachmentsLinks }, void 0);
};
export default Container;
